import React, { useMemo, useState } from "react";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { X } from "lucide-react";

export default function MultiSelectChips({ value = [], onChange, options = [], allowFree = false, testid, renderLabel }) {
  const [input, setInput] = useState("");
  // Optional label mapper — e.g. render language CODES as human names.
  // Backward-compatible: without `renderLabel`, the raw value is shown.
  const label = (v) => (typeof renderLabel === "function" ? renderLabel(v) : v);

  const availableOptions = useMemo(
    () => options.filter((o) => !value.includes(o)),
    [options, value]
  );

  const add = (v) => {
    if (!v) return;
    if (value.includes(v)) return;
    onChange([...value, v]);
    setInput("");
  };
  const remove = (v) => onChange(value.filter((x) => x !== v));

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        {value.map((v) => (
          <Badge key={v} variant="secondary" className="bg-accent/15 text-foreground border border-accent/30 pl-3 pr-1 py-1 gap-1">
            {label(v)}
            <button type="button" onClick={() => remove(v)} className="hover:bg-accent/30 rounded-full p-0.5" data-testid={`${testid}-remove-${v}`}>
              <X className="w-3 h-3" />
            </button>
          </Badge>
        ))}
      </div>
      {allowFree ? (
        <div className="flex gap-2">
          <Input data-testid={`${testid}-input`} placeholder="Type and press Enter" value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(input.trim()); } }}
          />
        </div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {availableOptions.map((o) => (
            <button type="button" key={o} onClick={() => add(o)} data-testid={`${testid}-add-${o.replace(/\s/g, "-")}`}
              className="text-xs px-3 py-1.5 rounded-full border border-border/60 hover:border-accent/60 hover:text-accent transition-colors text-muted-foreground">
              + {label(o)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
